import {createAction} from '@ngrx/store';


export class DialogWhereIsDatevClientIdActions {

  private static readonly prefix = '[Dialog Where Is DATEV Client ID]';

  public static open = createAction(
    `${this.prefix} Open dialog`,
  );

  public static close = createAction(
    `${this.prefix} Close dialog`,
  );

}
